module.exports = __webpack_public_path__ + "static/media/face-okki.ea732944.svg";